module.exports = __webpack_public_path__ + "static/img/fish50.39ce7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish50.png
// module id = c6Eb
// module chunks = 0